import { useParams } from "react-router-dom";
import data from "./dataCountry.json";
import "./country.css";

// ─── Reusable Icons ──────────────────────────────────────────────────────────
const GlobeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const GraduationIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
    <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
  </svg>
);

const BuildingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
    <path d="M9 22v-4h6v4"></path>
    <path d="M8 6h.01"></path>
    <path d="M16 6h.01"></path>
    <path d="M12 6h.01"></path>
    <path d="M12 10h.01"></path>
    <path d="M12 14h.01"></path>
    <path d="M16 10h.01"></path>
    <path d="M16 14h.01"></path>
    <path d="M8 10h.01"></path>
    <path d="M8 14h.01"></path>
  </svg>
);

const PlayIcon = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
    <polygon points="5 3 19 12 5 21 5 3"></polygon>
  </svg>
);

const BedIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const FoodIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v7c0 2.2 1.8 4 4 4h0c2.2 0 4-1.8 4-4V2" />
    <path d="M7 2v20" />
    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
  </svg>
);

const BusIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="3" width="16" height="16" rx="2" ry="2" />
    <path d="M4 11h16" />
    <path d="M12 3v8" />
    <path d="M8 19l-2 3" />
    <path d="M18 22l-2-3" />
    <path d="M8 15h.01" />
    <path d="M16 15h.01" />
  </svg>
);

const WalletIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
  </svg>
);

const getCostIcon = (name) => {
  if (name.includes("Tempat Tinggal")) return <BedIcon />;
  if (name.includes("Makan")) return <FoodIcon />;
  if (name.includes("Transport")) return <BusIcon />;
  if (name.includes("Gaji")) return <WalletIcon />;
  return null;
};

// ─── Section: Hero Banner ────────────────────────────────────────────────────
const HeroBanner = ({ country }) => {
  // Use first city image if a specific hero image isn't available, or fallback to background styling
  const bgImage = country.city && country.city[0] ? country.city[0].cityImage : "";

  return (
    <section className="country-hero-banner" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="country-hero-overlay"></div>
      <div className="container">
        <div className="country-hero-content animate__animated animate__fadeInUp">
          <p className="country-hero-subtitle">
            Guide to Living and Study
          </p>
          <h1 className="country-hero-title">
            {country.name}
          </h1>
          <div style={{ width: "60px", height: "4px", background: "#ff4d4f", marginBottom: "20px", borderRadius: "2px" }} />
          <p className="country-hero-desc">
            {country.guideBody}
          </p>
        </div>
      </div>
    </section>
  );
};

// ─── Section: Why ────────────────────────────────────────────────────────────
const WhySection = ({ country }) => {
  const icons = [<GlobeIcon key="1" />, <GraduationIcon key="2" />, <BuildingIcon key="3" />];

  // Dynamic collage using up to 2 city images
  const img1 = country.city && country.city[0] ? country.city[0].cityImage : "/assets/img/studytour/potong.png";
  const img2 = country.city && country.city[1] ? country.city[1].cityImage : "/assets/img/studytour/potong.png";

  return (
    <section className="country-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 mb-5 mb-lg-0 animate__animated animate__fadeInLeft">
            <div className="why-collage-wrapper">
              <img src={img1} className="why-collage-img-1" alt="Why Image 1" />
              <img src={img2} className="why-collage-img-2" alt="Why Image 2" />
            </div>
          </div>
          <div className="col-lg-7 ps-lg-5 animate__animated animate__fadeInRight">
            <h2 className="country-section-title">
              Mengapa Harus <br /><span className="red-text">{country.name}</span>
            </h2>

            <div className="why-list-container">
              {country.whyBody.map((w, i) => (
                <div className="why-list-item" key={i}>
                  <div className="why-icon-box">
                    {icons[i % icons.length]}
                  </div>
                  <p className="why-text">{w}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ─── Section: Campus Type ─────────────────────────────────────────────────────
const CampusSection = ({ country }) => (
  <section className="country-section pb-5 pt-0">
    <div className="container">
      <h2 className="country-section-title">
        Tipe <span className="red-text">Campus</span>
      </h2>

      <div className="row g-4">
        {country?.status?.map((item, id) => (
          <div className="col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: `${id * 0.1}s` }} key={id}>
            <div className="campus-card">
              <div className="campus-img-wrapper">
                <img src={item.image} className="campus-img" alt={item.institution} />
                <div className="campus-label-overlay">
                  {item.statusName}
                </div>
              </div>
              <div className="campus-body">
                {item.statusBody.map((b, idx) => (
                  <div className="campus-pill" key={idx}>
                    {b}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Cost Estimation */}
      <div className="mt-5 pt-5">
        <p className="text-center font-weight-bold mb-5" style={{ letterSpacing: '2px', fontSize: '14px', color: '#666' }}>
          ESTIMASI BIAYA HIDUP DAN PENDAPATAN
        </p>
        <div className="row g-4 justify-content-center">
          {country.cost.map((item, id) => {
            return (
              <div className="col-md-3 col-sm-6 animate__animated animate__fadeInUp" style={{ animationDelay: `${id * 0.1}s` }} key={id}>
                <div className="premium-cost-card">
                  <div className="cost-icon-wrapper">
                    {getCostIcon(item.costName)}
                  </div>
                  <h3 className="premium-cost-name">{item.costName}</h3>
                  <div className="premium-cost-price-box">
                    <span className="premium-cost-label">{item.estimate}</span>
                    <h4 className="premium-cost-amount">Rp. {item.costPrice.split('/')[0].trim()}</h4>
                    <span className="premium-cost-period">/ {item.costPrice.split('/')[1]?.trim() || "Minggu"}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

// ─── Section: Cities ──────────────────────────────────────────────────────────
const CitiesSection = ({ country }) => (
  <section className="country-section pt-0">
    <div className="container">
      <h2 className="country-section-title">
        Kota di <span className="red-text">{country.name}</span>
      </h2>

      <div className="row g-4">
        {country.city.map((item, id) => (
          <div className="col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: `${id * 0.1}s` }} key={id}>
            <div className="visit-card">
              <div className="visit-img-wrapper">
                <img src={item.cityImage} className="visit-img" alt={item.cityName} />
              </div>
              <div className="visit-card-body">
                <h3 className="visit-title">{item.cityName}</h3>
                <p className="visit-desc">{item.cityDesc}</p>
                {/* <a href="#!" className="btn-visit">
                  Visit
                  <span className="btn-visit-icon"><PlayIcon /></span>
                </a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ─── Section: Things to Do ────────────────────────────────────────────────────
const ActivitiesSection = ({ country }) => (
  <section className="country-section activities-section">
    <div className="container">
      <div className="activities-title animate__animated animate__fadeInRight">
        Things to do in <br />
        <span className="activities-title-country">{country.name}</span>
      </div>

      <div className="row g-4">
        {country.activity.map((item, id) => (
          <div className="col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: `${id * 0.1}s` }} key={id}>
            <div className="visit-card">
              <div className="visit-img-wrapper">
                <img src={item.activityImage} className="visit-img" alt={item.activityName} />
              </div>
              <div className="visit-card-body">
                <h3 className="visit-title">{item.activityName}</h3>
                <p className="visit-desc">{item.activityDesc}</p>
                {/* <a href="#!" className="btn-visit activity-card-btn">
                  Visit
                  <span className="btn-visit-icon activity-card-btn-icon"><PlayIcon /></span>
                </a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ─── 404 Not Found ────────────────────────────────────────────────────────────
const NotFound = () => (
  <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#333" }}>
    <span style={{ fontSize: 80 }}>🌏</span>
    <h2 style={{ fontSize: 32, fontWeight: 800 }}>404</h2>
    <p style={{ color: "#888" }}>Negara tidak ditemukan</p>
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const Country = () => {
  const { code } = useParams();
  const country = data.country.find((c) => c.code === code);

  if (!country) return <NotFound />;

  return (
    <div className="country-page-wrapper">
      <div className="country-bg-blob-1"></div>
      <div className="country-bg-blob-2"></div>
      <div className="country-bg-blob-3"></div>

      <HeroBanner country={country} />
      <WhySection country={country} />
      <CampusSection country={country} />
      <CitiesSection country={country} />
      <ActivitiesSection country={country} />
    </div>
  );
};

export default Country;